export const retrieveAWBNumber = (awb: string): string => {
  awb = awb?.replace("-", "");
  if (awb) {
    return `${awb.slice(3)}`;
  }
  return awb;
};

export const retrieveAWBPrefix = (awb: string): string => {
  awb = awb?.replace("-", "");
  if (awb) {
    return `${awb.slice(0, 3)}`;
  }
  return awb;
};
